




































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SelectAttribute extends Vue {
  @Prop()
  value?: boolean;

  @Prop({ default: () => [] })
  choices?: any;

  chosen: any = [];

  handleClickSubmit() {
    if (Object.keys(this.chosen).length === this.choices.length) {
      this.$emit('close', this.chosen, this.choices[0].module_id);
      this.chosen = {};
    }
  }
}
